<template>
  <a-form
    class="mod-form"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <template v-if="type === 'mobile'">
      <a-form-item label="手机号码" v-if="loginType === 'ffp' && value !== ''">
        <a-input
          size="large"
          placeholder="请输入手机号"
          v-decorator="[
            'phone',
            {
              initialValue: value,
              rules: [],
              validateTrigger: 'blur'
            }
          ]"
          disabled
        >
          <span slot="addonBefore">{{ areaCodeText }}</span>
        </a-input>
      </a-form-item>
      <mobile-input
        v-else
        label="手机号码"
        :form="form"
        :validateHandler="handleMobileValidate"
        @change="onPhoneChange"
      ></mobile-input>
    </template>
    <a-form-item label="邮箱" v-else>
      <a-input
        size="large"
        placeholder="请输入邮箱地址"
        v-decorator="[
          'email',
          {
            initialValue: value,
            rules: [
              {
                pattern: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
                message: '请输入正确的邮箱地址'
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
        @blur="onEmailChange"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
      </user-slider-captcha>
    </a-form-item>
    <a-form-item label="手机验证码" v-if="type === 'mobile'">
      <user-verification-code placeholder="请输入手机动态码" size="large" actionText="获取手机动态码" :areaCode="areaCode" :smsType="smsType" :value="phone" :token="token" @change="onVerificationCodeChange">
      </user-verification-code>
    </a-form-item>
    <a-form-item label="邮箱验证码" v-else>
      <user-verification-code placeholder="请输入邮箱动态码" size="large" actionText="获取邮箱动态码" type="email" :smsType="smsType" :value="email" :token="token" @change="onVerificationCodeChange">
      </user-verification-code>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { binding, changeBinding } from '@/api/member'
import { thirdPartyBind, ffpBind } from '@/api/login'
import { validate } from '@/utils/validate'
import areaCodeOptions from '@/utils/areacode'
import eventBus from '../../../components/eventBus.js'
import { isMobile } from '@/utils/util'

export default {
  props: {
    action: {
      type: String,
      default: 'bind'
    },
    type: {
      type: String,
      default: 'mobile'
    },
    value: String,
    codeToken: String,
    event: {
      type: Number,
      default: 0
    },
    loginType: String
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      phone: '',
      areaCode: '',
      email: '',
      token: '',
      code: '',
      loading: false,
      errCode: ''
    }
  },
  computed: {
    smsType () {
      const { action, type } = this

      if (action === 'bind') {
        return type === 'mobile' ? 13 : 14
      } else {
        return type === 'mobile' ? 1 : 2
      }
    },
    areaCodeText () {
      const value = find(areaCodeOptions, { value: this.areaCode })

      return value ? value.title : '中国+86'
    }
  },
  created () {
    const { type, value } = this

    if (value) {
      if (type === 'mobile') {
        this.phone = value
      } else {
        this.email = value
      }
    }

    eventBus.$on('get-token', (value) => {
      this.onGetFinalToken(value)
    })
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields((errors, values) => {
        if (!errors) {
          if (this.codeToken) {
            this.change(values)
          } else {
            this.bind(values)
          }
        }
      })
    },
    async bind (values, firstToken) {
      try {
        const { token, finalToken, code, type, event, loginType, areaCode } = this

        if (!code) {
          this.$error({
            content: `请输入${type === 'mobile' ? '手机' : '邮箱'}动态码！`,
            centered: true
          })
          return
        }

        if (!token) {
          this.$error({
            content: '请拖动滑块完成验证！',
            centered: true
          })
          return
        }

        if (!finalToken) {
          this.$error({
            content: '请点击获取动态码！',
            centered: true
          })
          return
        }

        this.loading = true

        const params = {
          event
        }

        if (event === 1 || loginType === 'ffp' || loginType === 'thirdParty') {
          const method = loginType === 'ffp' ? ffpBind : thirdPartyBind
          const data = await method({
            phone: values.phone,
            areaCode: areaCode,
            smsCode: code,
            sliderCaptcha: finalToken
          })

          this.$message.success('登录成功')
          this.$ls.set('USER_CENTER_INFO', data)

          if (window.__MICRO_ROOT__) {
            // 微前端通信
            window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, {
              ...data,
              token: this.$ls.get('USER_CENTER_TOKEN')
            })
          } else {
            // iframe 通信，兼容飞系列微信授权登录
            window.userAppUserInfo = {
              ...data,
              token: this.$ls.get('USER_CENTER_TOKEN')
            }
            window.top.postMessage('Login::Success', '*')
          }
          return
        } else {
          if (type === 'mobile') {
            params.mobile = values.phone
            params.areaCode = areaCode
          } else {
            params.email = values.email
          }

          if (firstToken) {
            params.event = 1
            params.token = firstToken
          } else {
            params.code = code
            params.sliderCaptcha = finalToken
          }

          await binding(type, params)
        }

        this.$success({
          content: `绑定${type === 'mobile' ? '手机' : '邮箱'}成功！`,
          centered: true,
          onOk: () => {
            if (isMobile()) {
              window.__MICRO_ROOT__?.eventBus?.emit('BindingSetting::Success', null)
            } else {
              this.$router.replace('/account')
            }
          }
        })
      } catch (err) {
        if (err.code === 100010065) {
          this.$confirm({
            title: '温馨提示',
            content: err.message,
            centered: true,
            okText: '取消绑定',
            onOk: () => {},
            cancelText: '继续绑定',
            onCancel: () => {
              this.bind(values, err.data.token)
            }
          })
        } else if (err.code === 20004) {
          this.$router.replace({
            path: '/security',
            query: {
              hasAuth: 0,
              info: err.data.info
            }
          })
        } else if (err.code === 20014) {
          this.$router.replace({
            path: '/security',
            query: {
              hasAuth: 1,
              info: err.data.info
            }
          })
        } else {
          this.$refs.verify.refresh()
          this.$error({
            content: err.message,
            centered: true
          })
          if (err.code.toString().includes(1000)) {
            this.errCode = err.code
          }
        }

        this.loading = false
      }
    },
    async change (values) {
      try {
        const { token, finalToken, code, type, codeToken, event, areaCode } = this

        if (!code) {
          this.$error({
            content: `请输入${type === 'mobile' ? '手机' : '邮箱'}动态码！`,
            centered: true
          })
          return
        }

        if (!token) {
          this.$error({
            content: '请拖动滑块完成验证！',
            centered: true
          })
          return
        }

        if (!finalToken) {
          this.$error({
            content: '请点击获取动态码！',
            centered: true
          })
          return
        }

        this.loading = true

        const params = {
          verifyCode: code,
          type: event,
          sliderCaptCha: finalToken,
          token: codeToken
        }

        if (type === 'mobile') {
          params.phone = values.phone
          params.areaCode = areaCode
        } else {
          params.email = values.email
        }

        await changeBinding(type, params)

        this.$success({
          content: `修改${type === 'mobile' ? '手机' : '邮箱'}成功！`,
          centered: true,
          onOk: () => {
            if (event === 1) {
              this.$emit('next')
            } else {
              if (isMobile()) {
                window.__MICRO_ROOT__?.eventBus?.emit('BindingSetting::Success', null)
              } else {
                this.$router.replace('/account')
              }
            }
          }
        })
      } catch (err) {
        this.$refs.verify.refresh()
        this.$error({
          content: err.message,
          centered: true
        })

        this.loading = false
        if (err.code.toString().includes(1000)) {
          this.errCode = err.code
        }
      }
    },
    handleMobileValidate (rule, value, callback) {
      // 手机校验
      validate('login-owner-mobile', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onPhoneChange ({ areaCode, phone }) {
      this.areaCode = areaCode
      this.phone = phone
    },
    onEmailChange () {
      this.form.validateFields(['email'], (errors, values) => {
        if (!errors) {
          this.email = values.email
        } else {
          this.email = ''
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
      if (this.errCode.toString().includes(1000)) {
        this.finalToken = value
      }
    },
    onVerificationCodeChange (value) {
      this.code = value
    },
    onGetFinalToken (value) {
      this.finalToken = value
      this.errCode = ''
    }
  }
}
</script>
